var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('generic-crud',{attrs:{"service":_vm.service,"labelNome":"nome_categoria"}})}
var staticRenderFns = []

export { render, staticRenderFns }